import { HeadMeta } from 'components/HeadMeta';
import { getSharedPageProps } from 'components/Layout';
import {
  BlockRenderer,
  getAllContentPagePaths,
  getContentPage,
} from 'helpers/umbracoApi';
import { GetStaticPaths, GetStaticProps } from 'next';
import { ContentPage } from 'types/umbraco';

export default function Page({ blocks, meta }: ContentPage): JSX.Element {
  return (
    <>
      <HeadMeta {...meta} />
      <BlockRenderer items={blocks} />
    </>
  );
}
export const getStaticProps: GetStaticProps = async ({ params }) => {
  const path = Array.isArray(params.slug)
    ? params.slug.join('/')
    : params.slug.toString();

  const contentPage = await getContentPage(path);

  if (!contentPage) {
    return {
      notFound: true,
      revalidate: 20,
    };
  }

  const sharedPageProps = await getSharedPageProps();

  return {
    revalidate: 20,
    props: {
      slug: params.slug,
      ...contentPage,
      ...sharedPageProps,
    },
  };
};

export const getStaticPaths: GetStaticPaths = async () => {
  const allPages = await getAllContentPagePaths();
  const paths = allPages.map((x) => ({
    params: { slug: x.url.split('/').filter(Boolean) },
  }));

  return { paths, fallback: 'blocking' };
};
